<template>
  <textarea
    @input="$emit('input', $event.target.value || null)"
    :value="value"
    class="textarea"
    :class="{ 'textarea--design-new': design === 'new', 'textarea--error': error }"
  >
  </textarea>
</template>

<script>
export default {
  name: 'AppTextarea',
  props: {
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    },
    error: Boolean,
    value: String,
  },
}
</script>

<style scoped lang="sass">
.textarea
  display: block
  width: 100%
  min-height: 90px
  padding: 12px 25px 11px 12px
  background-color: #fff
  border: 1px solid $color-border
  box-sizing: border-box
  border-radius: 7px
  font-family: $font-family-base
  font-size: 13px
  font-weight: 400
  line-height: 15.5px
  color: $color-text-base
  transition: border-color 0.3s
  resize: none
  scrollbar-color: $color-theme #f2f3f8
  scrollbar-width: thin

  &::-webkit-scrollbar
    width: 2px

  &::-webkit-scrollbar-track
    border-radius: 5px
    background-color: #f2f3f8

  &::-webkit-scrollbar-thumb
    border-radius: 5px
    background-color: $color-theme

  &::placeholder
    color: #818181

  &:focus
    border-color: #aaa

  &[readonly]
    border-color: #ff9416

.textarea--error
  border-color: $color-error

.textarea--400
  width: 400px

.textarea--mh-250
  min-height: 250px

.family.textarea
  color: #000
  font-family: 'CoreSansCR', sans-serif
  font-size: 14px
  font-weight: 400

  &::placeholder
    color: #707070

.textarea--design-new
  min-height: 96px
  padding: $ui-space-12
  border-color: $ui-line-strong
  border-radius: $ui-control-radius
  color: $ui-ink
  font-family: $ui-font-body
  font-size: $ui-font-size-body
  line-height: 1.45
  scrollbar-color: $ui-muted $ui-surface-soft
  transition: border-color .15s ease

  &::placeholder
    color: $ui-subtle

  &:focus
    border-color: var(--ui-accent, #{$ui-blue})
    outline: 0

  &[readonly],
  &[disabled]
    border-color: $ui-line-strong
    background-color: $ui-surface-soft
    color: $ui-muted

  &.textarea--error
    border-color: $ui-red
</style>
